import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/ajix-hostel/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/ajix-hostel/src/styles/tailwind.css");
